<h2>{{ list?.name }}</h2>
<div *ngFor="let i of list?.items || []">
    <a [routerLink]="['/', 'vimeo', 'video', i.playlistItemId]">{{ i.name }}</a>
</div>
